// Sesión compartida entre Journey 1 (wizard) y Journey 2 (chat).
// Vive en memoria del módulo: sobrevive a los cambios de hash sin recarga.
// Nada de edad, cédula ni ingresos (invariante 1 · diseno.md).
export const session = {
  lead: null, // {momento, cuidar[], quienes, yapaga, nombre, tel, consent, go, caso}
  fromJ1: false,
  autoContinue: false,
  j1log: [],
  catalogOverrides: null, // AC12 · edición en vivo de primas (solo memoria; recargar vuelve al catálogo)
};

export function emptyLead() {
  return {
    momento: null,
    cuidar: [],
    quienes: null,
    yapaga: null,
    nombre: null,
    tel: null,
    consent: null, // {si, ts, texto}
    go: null,
    caso: null,
  };
}

export function resetSession() {
  session.lead = emptyLead();
  session.fromJ1 = false;
  session.autoContinue = false;
  session.j1log = [];
}

// Renglón de log del wizard con la forma del log de evidencia (journey 1)
// Contrato de agentes.md: regla · fila · dec (info/pasa/aviso/escala) · txt · agente · strike · ts
export function j1LogRow(screen, i) {
  return {
    turno: i + 1,
    journey: 1,
    strike: 0,
    agente: screen.agente,
    regla: screen.log.regla,
    fila: '—',
    dec: screen.log.dec,
    txt: screen.log.txt,
    ts: new Date().toISOString(),
  };
}

// --- Persistencia por WhatsApp (agentes.md §8b) · sin backend: localStorage ---
export const normalizeTel = (tel) => String(tel || '').replace(/\D/g, '') || 'anon';
const KEY = (tel) => `mbm:session:${normalizeTel(tel)}`;

// Guarda el estado de la conversación bajo la clave del WhatsApp del lead,
// para que una conversación abandonada pueda retomarse desde otro canal.
export function saveSession(state) {
  try {
    const tel = state.lead && state.lead.tel;
    localStorage.setItem(KEY(tel), JSON.stringify({ ...state, ts: new Date().toISOString() }));
  } catch (e) {
    /* localStorage no disponible: la demo sigue en memoria */
  }
}

export function loadSession(tel) {
  try {
    const raw = localStorage.getItem(KEY(tel));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

// Retoma (Fase 8): la sesión más reciente guardada por WhatsApp (mayor ts)
export function loadLatestSession() {
  try {
    let best = null;
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith('mbm:session:')) continue;
      const val = JSON.parse(localStorage.getItem(key));
      if (val && (!best || (val.ts || '') > (best.ts || ''))) best = val;
    }
    return best;
  } catch (e) {
    return null;
  }
}

